import React from "react";
import { motion } from "framer-motion";

const topics = [
  { title: "ADHD", img: "https://img.freepik.com/premium-vector/adhd-attention-disorder-prevent-adhd-vector-stock-illustration_100456-10568.jpg", link: "https://applications.emro.who.int/docs/EMRPUB_leaflet_2019_mnh_214_en.pdf" },
  { title: "Depression", img: "https://st4.depositphotos.com/23877174/25249/v/450/depositphotos_252490948-stock-illustration-depression-icon-vector-from-human.jpg", link: "https://www.who.int/news-room/fact-sheets/detail/depression" },
  { title: "Bipolar Disorder", img: "https://i0.wp.com/www.additudemag.com/wp-content/uploads/2021/07/GettyImages-1250310797.jpg", link: "https://applications.emro.who.int/docs/EMRPUB_leaflet_2019_mnh_216_en.pdf" },
  { title: "PTSD", img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTIB4hzxb2gqZY1oD5Key0bryI_xkC_0IUY3LObg_y2Hg&s", link: "https://applications.emro.who.int/docs/WHOEMMNH235E-eng.pdf?ua=1" },
  { title: "Schizophrenia", img: "https://i0.wp.com/mindsitenews.org/wp-content/uploads/2023/09/shutterstock_1519533587-schizophrenia.jpeg?resize=780%2C780&ssl=1", link: "https://www.who.int/news-room/fact-sheets/detail/schizophrenia" },
  { title: "Anxiety", img: "https://static01.nyt.com/images/2022/01/19/well/19good-anxiety/19good-anxiety-mediumSquareAt3X-v3.jpg", link: "https://www.who.int/news-room/fact-sheets/detail/anxiety-disorders" },
  { title: "Eating Disorder", img: "https://zinc.ca/wp-content/uploads/2023/04/zinc-eating-disorders.jpg", link: "https://www.nimh.nih.gov/health/statistics/eating-disorders" },
  { title: "Paranoia", img: "https://etimg.etb2bimg.com/photo/99479867.cms", link: "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC6420131/" },
];

const containerVariants = {
  hidden: { opacity: 0 },
  show: { opacity: 1, transition: { staggerChildren: 0.15 } },
};

const cardVariants = {
  hidden: { opacity: 0, y: 30 },
  show: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } },
};

const Home2 = () => {
  return (
    <section className="relative bg-gradient-to-b from-lightCream to-darkCream pb-20">
      {/* Custom SVG Top Wave (no image, only SVG markup) */}
      <div className="absolute top-0 left-0 w-full overflow-hidden leading-none rotate-180">
        <svg
          className="relative block w-full h-[100px] sm:h-[120px] md:h-[150px]"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1440 120"
          preserveAspectRatio="none"
        >
          <path
            d="
              M0,96 C360,160 360,40 720,80
              C1080,120 1080,20 1440,96
              L1440,120 L0,120 Z
            "
            fill="#00B997"
            fillOpacity="0.85"
          ></path>
          <path
            d="M0,96 Q360,30 720,96 Q1080,162 1440,96 L1440,120 L0,120 Z"
            fill="#C2F6E2"
            fillOpacity="0.6"
          ></path>
        </svg>
      </div>

      {/* Main Content */}
      <motion.div
        className="max-w-7xl mx-auto text-center px-6 pt-32"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        viewport={{ once: true }}
      >
        <h2 className="text-4xl font-extrabold text-[#02483E] mb-3">
          Mental Health
        </h2>
        <p className="text-[#3C3C3C] text-lg mb-14">
          Discover key mental health topics and resources for awareness and healing.
        </p>

        <motion.div
          className="grid gap-10 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4"
          variants={containerVariants}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
        >
          {topics.map((topic) => (
            <motion.div
              key={topic.title}
              variants={cardVariants}
              whileHover={{ y: -6, scale: 1.03 }}
              transition={{ type: "spring", stiffness: 180, damping: 15 }}
              className="bg-white/80 backdrop-blur-sm border border-darkCream shadow-md rounded-2xl p-6 flex flex-col items-center text-center transition-all"
            >
              <div className="relative w-32 h-32 mb-4">
                <img
                  src={topic.img}
                  alt={topic.title}
                  className="w-32 h-32 rounded-full object-cover border-4 border-lightLeafGreen/50 shadow-sm"
                />
                <div className="absolute inset-0 rounded-full bg-lightLeafGreen/5 hover:bg-lightLeafGreen/10 transition-all"></div>
              </div>
              <h3 className="text-xl font-semibold text-[#02483E] mb-3">
                {topic.title}
              </h3>
              <a
                href={topic.link}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block bg-lightLeafGreen hover:bg-[#009E82] text-white text-sm font-medium py-2 px-6 rounded-full transition-all shadow-sm"
              >
                Read More
              </a>
            </motion.div>
          ))}
        </motion.div>
      </motion.div>
    </section>
  );
};

export default Home2;
